import type { FaireProductEntity } from "../../entity_types/product";

export const p_kh5yw766n7: FaireProductEntity = {
  token: "p_kh5yw766n7",
  type: "product",
  name: "Trendy Player Anklet Set",
  brandToken: "b_eow5j1bbc8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ec06410673512c38a7b1b1212e2bd6e00853e287e74e916ce2d7e7687820fe61.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/96b68ba5a9b06497778f3bdf7eaf11f3a8f7bd58e78bbaeea11aef951c6a1887.jpeg",
    "https://cdn.faire.com/fastly/1f4256af3796614ca23e1938a91bd2a8b539910e9f29395379a5a54db544e89d.jpeg",
    "https://cdn.faire.com/fastly/54cd064f71d5f2debb893c0ab0673926382d81e9f0a498eeddfe791703788d12.jpeg",
  ],
  priceDollars: 14.94,
  description:
    "4 different anklets come in this set. Each piece is trendy and pretty. Can be worn together or individually as you wish. All adjustable sizes.\n\nLightening bold one 8” perimeter without stretch (stretch anklet). The other 3 anklets(chains) are same length of 8” with 2” extender.  \n\nGold plated Copper\n\nLead compliant\n\nMade in China",
  tags: [],
  msrpDollars: 29.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:59.184Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
